import { useMemo, useState } from 'react';

import { CutsheetInfo } from '../../../shared/split-slot/types';

export function useDrawerStates(slotContacts: (CutsheetInfo | null)[]) {
  const [drawerSlotIndex, setDrawerSlotIndex] = useState<number | null>(null);
  const [newBuyerSlotIndex, setNewBuyerSlotIndex] = useState<number | null>(
    null,
  );
  const [cutsheetDrawerSlotIndex, setCutsheetDrawerSlotIndex] = useState<
    number | null
  >(null);
  const [wizardSlotIndex, setWizardSlotIndex] = useState<number | null>(null);
  const [
    questionnaireResponseDrawerSlotIndex,
    setQuestionnaireResponseDrawerSlotIndex,
  ] = useState<number | null>(null);
  const [
    questionnaireEditWizardSlotIndex,
    setQuestionnaireEditWizardSlotIndex,
  ] = useState<number | null>(null);

  const cutsheetDrawerInfo = useMemo<CutsheetInfo | null>(() => {
    if (cutsheetDrawerSlotIndex == null) return null;
    return slotContacts[cutsheetDrawerSlotIndex] ?? null;
  }, [cutsheetDrawerSlotIndex, slotContacts]);

  const questionnaireResponseDrawerInfo = useMemo<CutsheetInfo | null>(() => {
    if (questionnaireResponseDrawerSlotIndex == null) return null;
    return slotContacts[questionnaireResponseDrawerSlotIndex] ?? null;
  }, [questionnaireResponseDrawerSlotIndex, slotContacts]);

  const questionnaireEditWizardInfo = useMemo<CutsheetInfo | null>(() => {
    if (questionnaireEditWizardSlotIndex == null) return null;
    return slotContacts[questionnaireEditWizardSlotIndex] ?? null;
  }, [questionnaireEditWizardSlotIndex, slotContacts]);

  return {
    drawerSlotIndex,
    setDrawerSlotIndex,
    newBuyerSlotIndex,
    setNewBuyerSlotIndex,
    cutsheetDrawerSlotIndex,
    setCutsheetDrawerSlotIndex,
    wizardSlotIndex,
    setWizardSlotIndex,
    cutsheetDrawerInfo,
    questionnaireResponseDrawerSlotIndex,
    setQuestionnaireResponseDrawerSlotIndex,
    questionnaireResponseDrawerInfo,
    questionnaireEditWizardSlotIndex,
    setQuestionnaireEditWizardSlotIndex,
    questionnaireEditWizardInfo,
  };
}
